"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feePolicy = void 0;
exports.feePolicy = function (axios) {
    return {
        getFeePolicy: function (request) {
            return axios.get('/feepolicy/fees', request);
        },
        getFeesExcel: function (request) {
            axios.defaults.timeout = 30 * 60 * 1000;
            return axios
                .get('/feepolicy/fees/excel', request)
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        },
        getFeesSummaryExcel: function (request) {
            axios.defaults.timeout = 30 * 60 * 1000;
            return axios
                .get('/feepolicy/fees/summary/excel', request)
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        }
    };
};
